<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HgsDfT/tc-custom/9781467458191.jpg?1728413355287" alt="This image is the cover for the book Scandalous Witness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scandalous Witness
      </h1>
      <p class="bookDescription body article font2">
        <p>Christian identity is in moral and political crisis, scandalized by the many ways in which it has been coopted and misrepresented. Addressing this painful reality, Lee Camp writes that Christianity in America has been made into a bad public joke because of “our failure to rightly understand what Christianity <i>is</i>.” From this provocative claim, Camp’s manifesto makes the convincing case that a renewed Christian politic is more essential than ever, one that is “neither left nor right nor religious,” but a prophetic way of life modeled after Jesus of Nazareth. </p><p>Camp’s robust vision exposes modern parodies of faith—the American concept of “Christian values,” for one—and challenges Christians to rethink who they are and how they participate in the modern world. Authentic gospel truth is a scandal to the American myth, he argues, and we are called to be scandalous witnesses.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee C. Camp
      </h2>
      
      <p class="authorDescription body article"><B>Lee C. Camp </B>is a scholar of ethics and moral theology. He has published several books, including <I>Who Is My Enemy? Questions American Christians Must Face About Islam, and Themselves</I>, <I>Mere Discipleship: Radical Christianity in a Rebellious World</I>, and <I>Scandalous Witness: A Little Political Manifesto for Christians</I>, which was listed among the Best Books of 2020 by the Englewood Review. He taught theology and ethics at Lipscomb University for more than twenty years. He is also the creator and host of &ldquo;No Small Endeavor,&rdquo; an acclaimed podcast series that explores what it means to live a good life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?357a81f3